import { useCallback, useEffect, useMemo } from 'react';
import { SectionCard } from '../../components/card';
import { Separator } from '../../components/separator';
import { useAppSelector } from '../../redux/hook';
import ApplicationCooLayout from '../../layout/application-coo-layout';
import { useForm } from '../../hooks/use-form';
import { shared_documents_list } from '../../utils/shared/documents-list';
import { P2TextDescription } from 'react-bootstrap-common-script';
import OwnerOrOccupierReviewAccordion from '../../components/HOC/owner-review-accordion/owner-review-accordion';
import { isArray, size } from 'lodash';
import { validateReviewEndorse, validateReviewHoldingOwnerOccupier } from '../../utils/validator';
import { HoldingFormData, InitIncomingToHoldingFormData } from '../../models/polymer/HoldingFormData.model';
import { TextSubheader } from '../../components/text/text-subheader';
import ReviewHouseholdStructureTable from './review-endorse/review-household-structure-table';
import { useInitialWindowScrollTo } from '../../hooks/use-initial-window-scroll-to';
import ReviewDocument from './review-endorse/document';
import Declaration from './review-endorse/declaration';
import { ApplicationStep5 } from '../../models/classes/ApplicationStep5.class';
import ReviewEligibility from '../view-application/review-eligibility';
import QuestionAnswer from '../view-application/question-answer';
import ReviewFinancing from '../view-application/review-financing';
import ReviewConveyancing from '../view-application/review-conveyancing';

let activeStep = 5;

function StageAViewApplication() {
  useInitialWindowScrollTo();
  // const applicationStartFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  // const mainApplicantUinfin = applicationStartFormData.selected_hdb_property?.main_applicant_uinfin;

  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const applicationStep1FormData = useAppSelector((state) => state.app.ApplicationStep1Slice.formData);
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  const applicationStep4FormData = useAppSelector((state) => state.app.ApplicationStep4Slice.formData);
  // const initApplicationStep5FormData = useAppSelector((state) => state.app.ApplicationStep5Slice.formData);

  // const {
  //   values: holdingFormValues,
  //   errors: holdingFormErrors,
  //   // formValid: holdingFormValid,
  //   setFormValue: holdingSetFormValue,
  // }: // setAdditionalData,
  // {
  //   values: HoldingFormData;
  //   handleChange: any;
  //   errors: any;
  //   formValid: boolean;
  //   setFormValue: (update: HoldingFormData) => void;
  //   setAdditionalData: any;
  // } = useForm(new HoldingFormData(), () => {}, validateReviewHoldingOwnerOccupier);

  // const {
  //   values: ReviewEndorseValues,
  //   formValid: ReviewEndorseFormValid,
  //   setFormValue: ReviewEndorseSetFormValue,
  // }: { handleChange: any; values: ApplicationStep5; errors: any; formValid: boolean; setFormValue: (update: ApplicationStep5) => void } = useForm(
  //   new ApplicationStep5(),
  //   () => {},
  //   validateReviewEndorse
  // );

  const firstOwnerName = useMemo((): string => {
    return isArray(applicationStep1FormData.household.incoming_owners) && size(applicationStep1FormData.household.incoming_owners) > 0
      ? applicationStep1FormData.household.incoming_owners[0].myinfo?.name
      : '';
  }, [applicationStep1FormData]);

  // useEffect(() => {
  //   if (applicationStep1FormData.household) {
  //     let initHoldingFormData = new InitIncomingToHoldingFormData(applicationStep1FormData?.household);
  //     holdingSetFormValue(
  //       new HoldingFormData(
  //         initHoldingFormData.generateHoldingFormOwnerMainApplicantOnly(
  //           mainApplicantUinfin !== undefined ? mainApplicantUinfin : loginUser?.uinfin,
  //           applicationStartFormData.selected_hdb_property
  //         )
  //       )
  //     );
  //   }
  // }, [applicationStep1FormData, holdingSetFormValue, loginUser, applicationStartFormData.selected_hdb_property?.additional_roles]);

  // useEffect(() => {
  //   //INIT commonTenancy,
  // }, [initApplicationStep5FormData]);

  // useEffect(() => {
  //   ReviewEndorseSetFormValue(new ApplicationStep5({ input_verified: true }));
  // }, []);

  // const handleSetDeclarationCheckbox = useCallback(() => {
  //   ReviewEndorseSetFormValue({ ...ReviewEndorseValues, input_verified: true });
  // }, [ReviewEndorseValues, ReviewEndorseSetFormValue]);

  const submittedDocuments = useMemo(() => {
    const bankruptDocuments = applicationStep4FormData.file_items.filter((item) => item.code === 'DC10');
    const otherDocuments = applicationStep4FormData.file_items.filter((item) => item.code !== 'DC10');
    if (bankruptDocuments.length > 0 && bankruptDocuments.some((item) => item.uinfin === loginUser?.uinfin)) {
      return applicationStep4FormData.file_items;
    }
    return otherDocuments;
  }, [applicationStep4FormData.file_items, loginUser?.uinfin]);

  const documentList = useMemo(() => {
    return shared_documents_list.filter((item) => submittedDocuments.some((doc) => doc.code === item.code));
  }, [submittedDocuments]);

  const isProposed = useMemo(() => {
    return applicationStep1FormData.household.incoming_owners.some((item) => item.myinfo.uinfin === loginUser?.uinfin);
  }, [loginUser?.uinfin, applicationStep1FormData]);

  return (
    <ApplicationCooLayout>
      <div className='view-application-header'>
        <TextSubheader subheaderMain='Stage A: Start Application' subheaderSub={startApplicationFormData.selected_hdb_property?.address} />
      </div>

      <div className='d-flex justify-content-center view-application-section-card-container'>
        <SectionCard
          disabled={false}
          className='flex-fill'
          required={false}
          activeStep={activeStep}
          stepperItems={[]}
          titleChildren={<P2TextDescription title={'View Application'} />}
          contentChildren={
            <div>
              <div className='px-4 pb-5'>
                <ReviewHouseholdStructureTable />

                {/* Owners and Occupiers  */}
                {isProposed && (
                  <>
                    <div style={{ marginTop: 32 }}>
                      <div style={{ marginBottom: 16 }}>
                        <P2TextDescription color='#000' title='Proposed Household Details' />
                      </div>
                      <div style={{ marginTop: 16, marginBottom: 8 }}>
                        <P2TextDescription size='18px' color='#000' title={'Owners'} />
                      </div>
                      <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
                        {applicationStep1FormData.household.incoming_owners?.map((owner, _index) => {
                          const is_first_owner = _index === 0;
                          return (
                            <OwnerOrOccupierReviewAccordion
                              showMonthlyIncome={false}
                              isOwner={true}
                              enableMasking={true}
                              first_person={firstOwnerName}
                              is_first_person={is_first_owner}
                              key={owner.myinfo?.uinfin}
                              person={owner}
                            />
                          );
                        })}
                      </div>

                      {applicationStep1FormData.household.incoming_occupiers && applicationStep1FormData.household.incoming_occupiers.length > 0 && (
                        <>
                          <Separator style={{ margin: '32px 0' }} />
                          <div style={{ marginBottom: 8 }}>
                            <P2TextDescription size='18px' color='#000' title={'Occupiers'} />
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              gap: 8,
                              flexDirection: 'column',
                            }}>
                            {applicationStep1FormData.household.incoming_occupiers?.map((occupier) => {
                              return (
                                <OwnerOrOccupierReviewAccordion
                                  showMonthlyIncome={false}
                                  isOwner={false}
                                  first_person={firstOwnerName}
                                  key={occupier.myinfo?.uinfin}
                                  person={occupier}
                                  enableMasking={true}
                                />
                              );
                            })}
                          </div>
                        </>
                      )}
                      <div style={{ margin: '32px 0' }}>
                        <P2TextDescription required color='#000' title='Declaration in Ownership of Private Property' />
                      </div>
                      <QuestionAnswer
                        question={
                          'Does any of the proposed owners own or have an interest in a private property (including properties outside of Singapore)?'
                        }
                        answer={applicationStep1FormData.household.check_has_private_property ? 'Yes' : 'No'}
                      />
                      {applicationStep1FormData.household.check_has_dispose_property != null && (
                        <QuestionAnswer
                          question={
                            'Did any of the proposed owners relinquish their interest in any private property (including outside of Singapore) in the last 15 months?'
                          }
                          answer={applicationStep1FormData.household.check_has_dispose_property ? 'Yes' : 'No'}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
              <Separator variant='solid' />
              <ReviewEligibility />
              <Separator variant='solid' />
              <ReviewFinancing />
              <Separator variant='solid' />
              <ReviewConveyancing />
              <Separator variant='solid' />
              {submittedDocuments.length > 0 && (
                <>
                  <ReviewDocument
                    allowDownload={false}
                    document_list={documentList}
                    file_items={submittedDocuments}
                    submitted_documents_code={submittedDocuments.map((item) => item.code)}
                  />
                  <Separator variant='solid' />
                </>
              )}

              {/* 5. Contact Detail */}
              {/* <ReviewContactDetails
                isDisabled={true}
                proposed_owners={holdingFormValues.holding_owners}
                proposed_occupiers={holdingFormValues.holding_occupiers}
                holdingFormValues={holdingFormValues}
                holdingSetFormValue={holdingSetFormValue}
                holdingFormErrors={holdingFormErrors}
              /> */}

              {/** Note: 20 Nov 2025
               * Removed duplicate delaration
               * Unsure the need for accessing state value instead of hardcoding true as checkbox should not be able to be false at this stage.
               * Also disabled setFunction as acknowldgement is not editable at this stage and needed to be true to proceed to this stage.
               */}
              {/* <Declaration checkboxValue={ReviewEndorseValues?.input_verified} setCheckboxValue={handleSetDeclarationCheckbox} /> */}
              <Declaration checkboxValue={true} setCheckboxValue={() => {}} isDisabled={true} />
            </div>
          }
        />
      </div>

      <div style={{ margin: '32px 42px' }} />
    </ApplicationCooLayout>
  );
}

export default StageAViewApplication;
